var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"planComercial"},[_c('h3',[_vm._v("te invito a descargar mi plan comercial totalmente gratis")]),_vm._v(" "),_c('b-button',{attrs:{"href":"./static/Plan_Comercial.pdf","target":"_blank"}},[_vm._v("descargalo aquí")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-557302fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlanComercial.vue
// module id = null
// module chunks = 